export default "__VITE_ASSET__Btyl8rGD__"